<template>
  <div class="step-question-template medical-step-question">
    <div class="question-text" v-html="question.questionText"></div>
    <YesNo v-model="isResponseYes" :id="'yesno-' + question.id" :yes="true" :no="false" />

    <div class="question-error" v-if="yesnoErrorMessage">
      {{ yesnoErrorMessage }}
    </div>

    <div v-if="freeTextRequired">
      <div class="question-text" style="margin-top: 60px">
        {{ question.freeTextQuestion }}
      </div>
      <textarea class="question-additional-notes" v-model="freeTextResponse" />

      <div class="question-error" v-if="errorMessage">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import poster from "../mixins/poster";
import validator from "../mixins/validator";
import responseAdapters from "../mixins/responseAdapters";
import YesNo from "./YesNo.vue";

export default Vue.extend({
  mixins: [poster, validator],
  inject: ["isUs", "submitUrl", "csrfHeader", "csrf"],
  components: {
    YesNo,
  },
  props: {
    question: { required: true },
    showRequired: { required: true },
    first: { required: true },
    validate: { required: false, default: true },
  },
  data() {
    return {
      isResponseYes: this.question.isResponseYes,
      freeTextResponse: this.question.freeTextResponse,
      responseAdapter: responseAdapters.customFreeTextMedical,
    };
  },
  created() {
    this.$emit("answer", this.question, this.responseAdapter(this.question));
    if (this.isResponseYes != null) {
      this.hasDefaultAnswer = true;
      this.$emit("update-next-button-status", true);
    }
  },
  computed: {
    expectYes() {
      return this.question.expectYes;
    },
    isExpectedResponse() {
      return this.isResponseYes != null && this.isResponseYes === this.expectYes;
    },
    errorMessage() {
      if (this.validate && this.valid === false) {
        return this.question.rejectMessage;
      }

      if (this.showRequired && this.freeTextRequired && !this.hasFilledFreeText) {
        return "You must answer the question to continue";
      }

      return null;
    },
    yesnoErrorMessage() {
      if (this.showRequired && this.isResponseYes === null) {
        return "You must answer the question to continue";
      }

      return null;
    },
    valid() {
      if (this.isResponseYes === null) {
        return null;
      }
      if (this.freeTextRequired && !this.hasFilledFreeText) {
        return null;
      }
      return true;
    },
    freeTextRequired() {
      return this.isResponseYes != null && !this.isExpectedResponse;
    },
    hasFilledFreeText() {
      return this.freeTextResponse != null && this.freeTextResponse.length > 0;
    },
  },
  watch: {
    isResponseYes(newValue) {
      this.question.isResponseYes = newValue;
      if (newValue === this.question.expectYes) {
        this.freeTextResponse = null;
      }

      this.$emit("yesno-input-changed", newValue);
      this.save();

      if (this.isUs && !this.hasDefaultAnswer) {
        if (newValue === this.question.expectYes) {
          this.$emit("next");
        } else {
          this.$emit("update-next-button-status", true);
        }
      }
    },
    freeTextResponse(newValue) {
      this.question.freeTextResponse = newValue;
      this.save();
    },
  },
  methods: {
    save() {
      this.post(this.responseAdapter(this.question));
    },
  },
});
</script>
